<template>
    <div id="dashboard">
            <nav class="navbar is-dark is-fixed-top">
                <div class="container">
                    <div class="navbar-brand">

                        <router-link class="navbar-item" :to="routes.length > 0 ? routes[0].to : ''">
                            <img class="logo is-paddingless" v-bind:src="'/static/img/transparent.png'">
                            <section class="hero is-hidden-mobile">
                                <div class="hero-body">
                                    <div class="">
                                        <h1 class="title has-text-primary">
                                            <img class="header" v-bind:src="'/static/img/header.png'">
                                        </h1>
                                    </div>
                                </div>
                            </section>
                        </router-link>
                        <div class="navbar-burger burger is-hidden-desktop" data-target="navbar-mobile">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <!--<div class="navbar-menu">
                    <div class="navbar-end">
                        <div class="navbar-item has-dropdown is-hoverable">
                            <router-link class="navbar-link" to="/dashboard/profile">
                                <div class="level-item has-text-centered">
                                    <div v-if="me.id">
                                        <figure class='image is-48x48'>
                                            <img class='round' :src="axios.defaults.storageURL + me.profile.avatar">
                                        </figure>
                                    </div>
                                </div>
                            </router-link>
                            <div class="navbar-dropdown">
                                <router-link class="navbar-item" to="/dashboard/profile">
                                    Profile
                                </router-link>
                                <hr class="navbar-divider">
                                <a class="navbar-item" href="javascript:{}" @click="logout()">
                                    Logout
                                </a>
                            </div>
                        </div>
                    </div>
                </div>-->
            </nav>
            <div class="columns is-multiline" style="margin-bottom: 100px;">
                <div class="column is-2">
                    <div class="menu columns box">
                        <div class="column">
                          <aside>
                              <p class="menu-label is-2">
                                Dashboard
                              </p>
                              <ul class="menu-list">
                                  <li v-for="route in routes">
                                      <router-link :to="route.to" v-bind:class="{'is-active': routeMatch(route.to)}">
                                          <span class="icon"><i class="fa" v-bind:class="route.icon"></i></span> {{route.heading}}
                                      </router-link>
                                  </li>
                                  <li>
                                      <a href="#" class="" @click="logout()">
                                          <span class="icon"><i class="fa fa-power-off"></i></span> Logout
                                      </a>
                                  </li>
                              </ul>
                          </aside>
                        </div>
                    </div>
                </div>
                <div class="column is-10 is-12-mobile is-12-touch">
                    <transition name="fade">
                        <router-view></router-view>
                    </transition>
                </div>
            </div>

        <footer class="footer has-shadow fix-footer">
          <div class="container">
              <div class="content has-text-centered">
                  <div class="columns is-multiline" style="margin-bottom: -20px">
                      <div class="column is-4 has-text-left">
                          <router-link to="/dashboard/terms"><u>Terms and Conditions</u></router-link>
                      </div>
                      <div class="column is-4 has-text-centered">
                          <router-link to="/dashboard/ticket"><u>Contact us</u></router-link>
                      </div>
                      <div class="column is-4 has-text-right">
                          <router-link to="/dashboard/privacy"><u>Privacy policy</u></router-link>
                      </div>
                  </div>
                  <p>
                      <b>Copyright © {{new Date().getFullYear()}} <span class="has-text-primary">BlaBla Commentz</span></b>
                  </p>
              </div>
          </div>
        </footer>
    </div>
</template>

<script>
import Vue from 'vue'
import UserRepo from './repos/UserRepo'

export default {
    name: 'dashboard',
    components: {},
    data(){
      return {
          me: {
            profile: {}
          },
          isAffiliate: false,
          routes: [],
          adminRoutes : [
              {
                  heading: 'News',
                  icon: 'fa-bullhorn',
                  to: '/dashboard/news'
              },
              {
                  heading: 'Tickets',
                  icon: 'fa-envelope',
                  to: '/dashboard/tickets'
              },
              {
                  heading: 'Users',
                  icon: 'fa-users',
                  to: '/dashboard/users'
              },
              {
                  heading: 'Users Export',
                  icon: 'fa-file-excel-o',
                  to: '/dashboard/users-export'
              },
              // {
              //     heading: 'Magic Words',
              //     icon: 'fa-magic',
              //     to: '/dashboard/magic-words'
              // },
              {
                  heading: 'Categories',
                  icon: 'fa-th-list',
                  to: '/dashboard/categories'
              },
              {
                  heading: 'Premade Categories',
                  icon: 'fa-list-alt',
                  to: '/dashboard/premade-categories'
              },
              {
                  heading: 'Sentences',
                  icon: 'fa-pencil',
                  to: '/dashboard/sentences'
              },
              {
                  heading: 'Premade Sentences',
                  icon: 'fa-pencil-square',
                  to: '/dashboard/premade-sentences'
              },
              {
                  heading: 'Comments',
                  icon: 'fa-coffee',
                  to: '/dashboard/comments'
              },
              {
                  heading: 'Premade Comments',
                  icon: 'fa-inbox',
                  to: '/dashboard/premade-comments'
              },
              {
                  heading: 'Schools',
                  icon: 'fa-graduation-cap',
                  to: '/dashboard/schools'
              },
              {
                  heading: 'Students',
                  icon: 'fa-user-circle',
                  to: '/dashboard/students'
              },
              {
                  heading: 'Lessons',
                  icon: 'fa-book',
                  to: '/dashboard/lessons'
              },
              {
                  heading: 'StandBy Lessons',
                  icon: 'fa-book',
                  to: '/dashboard/sb-lessons'
              },
              {
                  heading: 'StandBy Lesson Changes',
                  icon: 'fa-sticky-note-o',
                  to: '/dashboard/sb-lesson-changes'
              },
          ],
          affiliateRoutes: [
              {
                  heading: 'Stats',
                  icon: 'fa-credit-card-alt',
                  to: '/dashboard/stats'
              },
          ],
          repo: new UserRepo(this.$auth)
      }
    },
    created(){
        let md = new MobileDetect(window.navigator.userAgent);
        if(md.mobile()){
          this.$swal({
            type: 'error',
            confirmButtonText:  'I understand <i class="fa fa-thumbs-up"></i>',
            focusConfirm: false,
            confirmButtonColor: '#f27474',
            text: 'This application is not intended for use on mobile phones!',
          });
        }

        if(this.$me.id != -1) {
            this.me = this.$me;
            this.checkAffiliate();
        }
        else{
            this.repo.me().then(response => {
                Vue.prototype.$me = response.data.data;
                this.me = this.$me;
                this.checkAffiliate();
            });
        }
/*      if(this.schools.length == 0){
        this.loadSchools();
        console.log('call');
      }*/
    },
    methods: {
        logout: function () {
            let component = this;
            this.$auth.logout().then(function () {
                component.$router.push('/');
            }).catch(function(){
                component.$router.push('/');
            }).finally(function() {
                Vue.prototype.$me = {
                    price: 0,
                    user: {
                        profile: {
                            name: ''
                        },
                        news : [],
                        unseenNews :[]
                    },
                    id: -1
                };
            });

        },
        routeMatch(path){
            return this.$route.path == path;
        },
        checkAffiliate(){
          if(this.me.id && this.me.id != -1 && this.me.roles && this.me.roles.length > 0){
              for(let i = 0; i < this.me.roles.length; i++){
                  if(this.me.roles[i].name == 'affiliate'){
                        this.isAffiliate = true;
                        this.routes = this.affiliateRoutes;
                        this.$router.push('/dashboard/stats');
                        return;
                  }
              }
              //this.routes = this.affiliateRoutes;
              this.routes = this.adminRoutes;
          }
        }
  }
}
</script>

<style scoped>

.navbar{
    margin-bottom: 10px !important;
    border: none;
}
.navbar.columns{
    padding: 5px;
}

.navbar .hero-body{
    padding: 0px;
    padding-top: 10px;
    padding-left: 5px;
}
.menu{
    padding-left: 5px;
    padding-right: 1px;
}
.collapse-item{
    z-index: 19;
}

figure.avatar{
    width: max-content;
}

nav{
    background-color: #3D4351 !important;
}

.navbar-item img {
    max-height: 3.75rem;
}

.navbar-item div, navbar-item .navbar-link{
    color: white;
}

.navbar-item.is-active{
    border-bottom: 4px solid #00d1b2;
    margin-bottom: -1px;
}

.navbar-item {
    padding: 0.5rem 1rem;
}

.navbar-item .logo{
    max-height: 4.25rem;
    margin-right: 1rem;
}

.navbar-item .header{
    max-height: 3.25rem;
}

nav .subtitle{
    color:white;
}

nav a.navbar-item{
color: #00d1b2;
}

nav a.navbar-item:hover{
color: #00d1b2;
}
nav .navbar-item.has-dropdown a::after{
    border: none;
}

nav .navbar-item.has-dropdown .navbar-link{
    padding: 0px !important;
}

nav .navbar-item.has-dropdown:hover{
    background-color: #292929;
    color: #ddd;
}


nav .navbar-item.has-dropdown{
    padding: 0.5rem 1rem;
}

nav .navbar-end{
    margin-left: -146px;
}
</style>



// WEBPACK FOOTER //
// src/Dashboard.vue